/*
 * @Author: cc
 * @Date: 2019-12-26 11:46:35
 * @LastEditTime: 2021-12-28 11:13:06
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\trill\toBeCompiled\toBecompiled.js
 * @Description: 抖音渠道待编模块
 */
'use strict';

angular.module('editTrillToBeCompiledModule', ['editTrillToBeCompiledRouterModule']).controller('EditTrillToBeCompiledCtrl', [
    '$scope',
    '$state',
    '$controller',
    'initTrillEditerBtnService',
    'trillConst',
    function (
        $scope,
        $state,
        $controller,
        initTrillEditerBtnService,
        trillConst
    ) {
        initStatus();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.trenchStatus = {
                // eslint-disable-next-line camelcase
                status_model: 0, // 后台用来区分待编、待审、已签发
            };
            $scope.trenchData = {
                trenchConst: trillConst, // 渠道需要的常量
            };
            $scope.trenchParams = {
                serviceid: 'mlf_douyin',
                methodName: 'queryToEdit',
                SelectFields: 'ChannelId ACCOUNTID,DocType,CrUser,Title,cover_tsp,errormsg,original,POI_NAME,POI_ID',
            };
            $scope.trenchRightsParams = {
                methodname: 'queryOperKeyOfDouYin',
                Classify: 'douyin.daibian',
                douYinAccountId: $state.params.account,
            };
            $scope.distributionMethodName = 'douyinDaiBianDistribute'; // 多元分发接口名
            $controller('EditShortVideoListCtrl', {$scope: $scope}); // 控制器继承
        }

        /**
         * [routerToDraftPage description] 跳转到编辑页
         * @param   {[object]}  item      [account description] 稿件信息
         * @return  {[type]}              [return description]
         */
        $scope.routerToDraftPage = function (item) {
            initTrillEditerBtnService.trillEditor($state.params.account, item ? item.DOUYINARTICLEID : '', $scope.trenchStatus.status_model);
        };
    },
]);
